module.exports = "/assets/data/a75169adddcd5066d25809ba8d94e8ca-DT6.data.json";